module.exports = __webpack_public_path__ + "642f562014f2b0f2f44b6d39f85accfd.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/UM.svg
// module id = 6agN
// module chunks = 0